<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-list-item-avatar v-if="avatarUrl" v-on="on" size="25">
          <v-img :src="avatarUrl"></v-img>
        </v-list-item-avatar>
        <v-avatar v-on="on" color="primary mr-2" v-else size="25">
          <span class="white--text" v-if="fullName">{{
            fullName.charAt(0)
          }}</span>
        </v-avatar>
      </template>
      <span v-if="title">{{ title }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  props: ["avatarUrl", "fullName", "title"],
};
</script>